<template>
    <div class="doctorMenu">
        <doctor-menu-info
            :menu="menu"
            :user="user"
            :user-coupons="filteredUserCoupons"
            :with-repeatable-date="withRepeatableDate"
            user-type="doctor"
            doctor-introduction-type="history">
        </doctor-menu-info>
        <b-button
            v-if="selectable"
            class="nextButton mt-4"
            @click="onSelect">
            日時選択へ進む
        </b-button>
    </div>
</template>

<script>
    import constants from '../../constants'
    import helper from '../../YokumiruHelper'
    import YokumiruHelper from "../../YokumiruHelper";

    export default {
        props: {
            menu: {
                type: Object,
                required: true,
            },
            user: {
                type: Object|null,
                default: null,
            },
            withRepeatableDate: {
                type: Boolean,
                default: false,
            },
            selectable: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * 所持クーポンのフィルタリング
             * （相談予約カテゴリのクーポンだけにする）
             *
             * @return {array}
             */
            filteredUserCoupons: function () {
                if (!this.user) return []

                return this.helper.filteredUserCoupons(this.user)
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
            }
        },

        methods: {
            onSelect: function () {
                if (!this.selectable) return

                bus.$emit('selected-doctor-doctor-menu', this.menu)
            },
        },
    }
</script>

<style lang="scss" scoped>
.doctorMenu {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 100%;
    max-width: 720px;
    padding: 25px;
    background-color: #f9f9f9;
    border: 1px solid #dee2e6;
    border-radius: 6px;
}

.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}
</style>
